import styled from 'styled-components';
import { AppTitle } from 'components/atoms/CommonAppComponents/AppTitle/AppTitle';

export const AppModalTitle = styled(AppTitle)`
    margin: 0;
    text-align: center;
`;
